import * as React from 'react';
import { useState } from 'react';
import ProductForm from "../../components/Products/ProductForm/ProductForm";
import Submenu from '../../components/Submenu/Submenu';
import AppMenus from '../../config/appMenus';
import AppRoutes from '../../config/appRoutes';
var Product = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editProduct.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u043F\u0440\u043E\u0434\u0443\u043A\u0442"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(ProductForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Product;



//////////////////
// WEBPACK FOOTER
// ./src/views/Products/Product.tsx
// module id = 404
// module chunks = 0